import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { translation } from "Slices/translation/reducer";
import { toast } from "react-toastify";


export const getReferralReward = createAsyncThunk("referralReward/getReferralReward", async () => {
  try {
    const response = await axios.get(`/GetUserReferralReward`);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const addUserRequest = createAsyncThunk("referralReward/addUserRequests", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/AddUserRequests`, data);
    toast.success(translation?.Referral?.OurManagerContactYou || response.message);
    return response.data;
  } catch (error) {
    if (error.response.status === 403) {
      toast.error(translation?.Referral?.RequestAlreadyExist || error.message);
    } else {
      toast.error(translation?.Referral?.SomethingWentWrong || error.message);
    }
    return thunkAPI.rejectWithValue(error.response?.data || error || "Something went wrong");
  }
});

export const getProgram = createAsyncThunk("referralReward/getProgram", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetProgram`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error || "Something went wrong");
  }
});

export const addFriendsDetail = createAsyncThunk("referralReward/addFriendsDetail", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/AddFriendsDetail`, data);
    toast.success(translation?.Referral?.FriendsDetailAdded || response.message);
    return response.data;
  } catch (error) {
    toast.error(translation?.Referral?.SomethingWentWrong || error.message);
    return thunkAPI.rejectWithValue(error.response?.data || error || "Something went wrong");
  }
});

export const addFriendsProgram = createAsyncThunk("referralReward/addFriendsProgram", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/AddFriendsProgram`, data);
    toast.success(translation?.Referral?.ProgramAdded || response.message);
    return response.data;
  } catch (error) {
    toast.error(translation?.Referral?.SomethingWentWrong || error.message);
    return thunkAPI.rejectWithValue(error.response?.data || error || "Something went wrong");
  }
});